import { CreditCard, AlertTriangle } from 'lucide-react'

export const DepositInfoPanel = () => {
  return (
    <div className="rounded-2xl border border-card-border dark:border-card-border-dark p-4 md:p-5 bg-light-purple dark:bg-dark-purple">
      {/* Заголовок */}
      <div className="flex items-center gap-2 mb-3">
        <CreditCard className="w-5 h-5 text-primary dark:text-primary-dark" />
        <span className="font-semibold text-main-black dark:text-white text-base">
          Пополнение депозита
        </span>
      </div>

      {/* Информация о комиссии */}
      <div className="text-sm text-text-secondary space-y-3">
        <p>
          При сумме пополнения до <span className="font-semibold">3000 $</span>{' '}
          <span className="text-primary dark:text-primary-dark underline">комиссия = 15 $</span>.
        </p>
        <p>
          При сумме пополнения от <span className="font-semibold">3000 $</span> и выше{' '}
          <span className="text-primary dark:text-primary-dark underline">комиссия 0 $</span> (без
          комиссии).
        </p>
      </div>

      <hr className="my-4 border-card-border dark:border-card-border-dark" />

      {/* Важно */}
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="w-5 h-5 text-yellow-500" />
        <span className="font-semibold text-main-black dark:text-white text-base">Важно:</span>
      </div>
      <div className="text-sm text-text-secondary space-y-3">
        <p>
          Рекомендуем отправлять средства только с проверенных бирж — Bybit, Binance, HTX и аналогичных крупных площадок.
        </p>
        <p>
          Переводы с сомнительных источников или непроверенных кошельков будут отклонены и приведут к возврату средств.
        </p>
      </div>
    </div>
  )
}
